import type {
  ICourseAccessCodesDto,
  ICourseAccessCodesResponse,
} from "./types";
import type { IPathBaseParam } from "./path";
import { exportQrCodes } from "./exportQRCodes/api";

import type { IApiResponse, IPagination, IPaginationParams } from "@/api";
import { axiosClient } from "@/api/clients";
import { createGetAllApi } from "@api/util/createGetAllApi";
import { createPostApi } from "@api/util/createPostApi";
import { createDeleteApi } from "@api/util/createDeleteApi";
import type { ICourseResponse } from "@api/courses/types";
import { getApi } from "@api/apiPath";
import type { IFileResponse } from "@/interfaces";

const getAllApis = createGetAllApi<
  IApiResponse<
    IPagination<ICourseAccessCodesResponse, { course: ICourseResponse }>
  >,
  IPathBaseParam,
  IPaginationParams
>("courses.accessCodes");
const postApis = createPostApi<
  IApiResponse<ICourseAccessCodesResponse>,
  IPathBaseParam,
  ICourseAccessCodesDto
>("courses.accessCodes");
const deleteApis = createDeleteApi<
  IApiResponse<ICourseAccessCodesResponse>,
  IPathBaseParam
>("courses.accessCodes");

const { getPath } = getApi("courses.accessCodes.getAll");

const downloadApi = async ({
  courseId,
}: IPathBaseParam): Promise<IApiResponse<IFileResponse>> => {
  return axiosClient.get(getPath({ courseId }), {
    headers: {
      Accept: "text/csv",
    },
  });
};

export const accessCodes = {
  ...getAllApis,
  ...postApis,
  ...deleteApis,
  downloadApi,
  exportQrCodes,
};
